<template>
  <div id="app">
    <router-view/>
    <Footer v-show="this.$route.meta.footerShow"></Footer>
    <mhead v-show="this.$route.meta.navShow"></mhead>
  </div>
</template>

<script>
  import Head from "./views/common/Head.vue";
  import mhead from "./views/common/mhead.vue";
  import Footer from "./views/common/Footer.vue";
export default {
  name: 'App',
  data(){
    return {
      flag:true
    }
  },
  components: {
    Head,
    mhead,
    Footer
  }
}
</script>

<style>
  * {
    padding: 0;
    margin: 0;
  }

  /*table {border-collapse:collapse;border-spacing:0;}*/
  fieldset, img {
    border: 0
  }

  address, caption, cite, code, dfn, em, strong, th, var {
    font-style: normal;
    font-weight: normal
  }

  ol, ul {
    list-style: none
  }

  caption, th {
    text-align: left
  }

  h1, h2, h3, h4, h5, h6 {
    font-size: 100%;
    font-weight: normal
  }

  q:before, q:after {
    content: ''
  }

  abbr, acronym {
    border: 0
  }

  a {
    text-decoration: none;
  }
  /*span{*/
    /*display: inline-block;*/
  /*}*/
  html, body {
    font-size: 16px;
    /*background-color: white;*/
    background-color: #f6f7f9;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue